import { ENTITY_TYPE } from "@/services/assignment/constants";
import graphqlRequest from "../assignmentRequest";
import GET_STUDENT_ASSIGNMENTS from "./getStudentAssignmentsGraphql";
import { AssignmentStatus, AssignmentType } from "@/enums";

export async function getStudentAssignments(
  classroomId,
  dateFrom,
  dateTo
) {
  let inputs = {
    classId: classroomId,
    filter: {
      assignmentType: [AssignmentType.CURRICULUM, AssignmentType.INSTRUCT],
      status: [
        AssignmentStatus.ASSIGNED,
        AssignmentStatus.IN_PROGRESS,
        AssignmentStatus.COMPLETE,
        AssignmentStatus.DONE,
      ],
      entityType: [ENTITY_TYPE.STUDENT],
      dateFrom,
      dateTo,
    },
  };

  return await graphqlRequest(GET_STUDENT_ASSIGNMENTS, inputs);
}
